// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ContentComponentItemFragmentDoc } from './ContentComponentItem.fragment.generated';
export const ComponentContentFragmentDoc = gql`
    fragment componentContent on ComponentContent {
  __typename
  content {
    ...contentComponentItem
  }
}
    ${ContentComponentItemFragmentDoc}`;